import { createContext } from 'react';

type SelectContextConfig = {
    size: 'standard' | 'small';
    menuOpen?: boolean;
    position: 'relative' | 'absolute';
    borderStyle: 'underline' | 'border';
    errorMessage?: string;
};

export const SelectContext = createContext<SelectContextConfig>({
    size: 'standard',
    position: 'absolute',
    borderStyle: 'border',
    errorMessage: undefined,
});
